export class DataFieldsEntity {
    public isPrimaryKey = false;
    public fieldName = '';
    public fieldNameValid = false;
    public dataType: number;
    public isActive = true;
    public editable = false;
    public objectId = '';
    public disableEditBtn = false;

    constructor() { }

}